import ContentLoader from 'react-content-loader';
import styled, { useTheme } from 'styled-components';
import { PHONE_MEDIA_QUERY } from '../../common/responsive';

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 20px;
  padding: 2px 20px;
  max-height: 280px;
  overflow: hidden;
`;

const GridItem = styled.div`
  background-color: ${({ theme }) => theme.background.primary};
  border-radius: 16px;
  display: flex;
  width: 297px;
  height: 270px;
  flex-direction: column;
  align-items: center;
  transition: transform 0.3s ease;
  position: relative;
  background-color: ${({ theme }) => theme.background.light};
  @media (hover: hover) {
    &:hover {
      transform: translateY(-5px);
    }
  }
  @media ${PHONE_MEDIA_QUERY} {
    width: 100%;
  }
  cursor: pointer;
`;

const GiftCardSkeleton = () => {
  const theme = useTheme();

  return (
    <GridItem>
      <ContentLoader
        speed={2}
        width={297}
        height={270}
        viewBox='0 0 297 270'
        backgroundColor={theme.background.secondary}
        foregroundColor={theme.special.skeleton}
      >
        <rect x='0' y='0' rx='15' ry='15' width='297px' height='270px' />
      </ContentLoader>
    </GridItem>
  );
};

const CardsSkeleton = () => {
  return (
    <GridContainer>
      <GiftCardSkeleton />
      <GiftCardSkeleton />
      <GiftCardSkeleton />
      <GiftCardSkeleton />
    </GridContainer>
  );
};

export default CardsSkeleton;
